import { Flashbar } from 'AWS-UI-Components-React';
import React from 'react';
import { ERROR_MESSAGE } from '../../../constants/views';
import { extractErrorMessage } from '../../../utilities';
import logger from '../../../utils/logging';
import { getJSClient } from '../../js_client';
import { ChannelMappingTable } from './channel_mapping_table';
import {
  getHCPChannelTypeOptions,
  getHCPChannelOptions,
  getCognosChannelOptions,
  getGroupCodeOptions,
  getMarketplaceIdOptions, getCognosParentChannelOptions,
} from './channel_mapping_utils';

export class ChannelMapperContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      channelMappings: [],
      dropdownOptions: {},
      errorScreenMessage: null,
      successScreenMessage: null,
      channelMappingsById: {},
      hcpChannelTypeOptions: [],
      hcpChannelOptions: [],
      originalChannelMappings: {},
    };
  }

  componentWillMount = () => {
    this.client = getJSClient();
    this.initialClientTasks();
  };

  initialClientTasks = () => {
    this.refreshChannelMapping();
  };

  stageChannelMappingChanges = (modifiedChannelMappingsById) => {
    const { channelMappingsById } = this.state;
    let stagedChannelMappings = [];
    if (Object.keys(modifiedChannelMappingsById).length > 0) {
      for (const id of Object.keys(modifiedChannelMappingsById)) {
        const channelMapping = channelMappingsById[id];
        channelMapping.hcpChannelType = modifiedChannelMappingsById[id].hcpChannelType;
        channelMapping.hcpMerchantChannel = modifiedChannelMappingsById[id].hcpMerchantChannel;
        channelMapping.phoenixChannel = modifiedChannelMappingsById[id].phoenixChannel;
        channelMapping.excluded = modifiedChannelMappingsById[id].excluded;
        channelMapping.ignored = modifiedChannelMappingsById[id].ignored;
        channelMapping.comments = modifiedChannelMappingsById[id].comments;
        stagedChannelMappings.push(channelMapping);
      }
    }

    this.setState({ channelMappingsById });

    const payload = this.convertToStageRequestPayload(stagedChannelMappings);
    this.client.stageChannelMapping(this.onStageChannelMappingSuccess, this.onStageChannelMappingFailure, payload);
  };

  convertToStageRequestPayload = (stagedChannelMappings) => {
    const payload = {};
    payload.channelMappings = stagedChannelMappings;
    payload.username = this.props.user;

    return payload;
  };

  onStageChannelMappingSuccess = (data) => {
    logger.info('Fetched staged channel mappings.');
    let stagedChannelMappings = data.channelMappings;
    const { channelMappings } = this.state;
    const channelMappingsWithStaged = channelMappings.reduce((obj, item) => ({...obj, [item['id']]: item}), {});
    for (const stagedMapping of stagedChannelMappings) {
      channelMappingsWithStaged[stagedMapping.id] = Object.assign(stagedMapping);
    }
    this.setState({ errorScreenMessage: null,
                    stagedChannelMappings: data.channelMappings,
                    channelMappings: Object.values(channelMappingsWithStaged),
                    channelMappingsById: channelMappingsWithStaged,
    });
  };

  onStageChannelMappingFailure = (error) => {
    logger.error(error);
    this.setState({ errorScreenMessage: extractErrorMessage(error) });
  };

  unstageChannelMappingChanges = (modifiedChannelMappingsById, latestChannelMappingsById) => {
    const { channelMappingsById } = this.state;
    let channelMappingsToUnstage = [];
    for (const id of Object.keys(modifiedChannelMappingsById)) {
      let channelMappingIdentifier = {};
      channelMappingsById[id] = { ...latestChannelMappingsById[id] };
      channelMappingIdentifier.id = channelMappingsById[id].id === undefined ? id : channelMappingsById[id].id;
      channelMappingIdentifier.version = this.props.user;
      channelMappingsToUnstage.push(channelMappingIdentifier);
    }

    const payload = this.convertToUnstageRequestPayload(channelMappingsToUnstage);
    this.client.unstageChannelMapping(this.onUnstageChannelMappingSuccess, this.onUnstageChannelMappingFailure, payload);
  };

  convertToUnstageRequestPayload = (channelMappingsToUnstage) => {
    const payload = {};
    payload.channelMappings = channelMappingsToUnstage;
    payload.username = this.props.user;

    return payload;
  };

  onUnstageChannelMappingSuccess = () => {
    this.refreshChannelMapping();
    logger.info('Unstaging channel mapping succeeded.');
    this.setState({ errorScreenMessage: null, successScreenMessage: "Successfully unstaged" });
  };

  onUnstageChannelMappingFailure = (error) => {
    logger.error(error);
    this.setState({ errorScreenMessage: extractErrorMessage(error) });
  };

  publishChannelMappingChanges = (stagedChannelMappingIds, latestChannelMappingsById) => {
    const { channelMappingsById } = this.state;
    let channelMappingsToPublish = [];
    for (const id of Object.keys(stagedChannelMappingIds)) {
      let channelMappingIdentifier = {};
      channelMappingsById[id] = { ...latestChannelMappingsById[id] };
      channelMappingIdentifier.version = this.props.user;
      channelMappingsById[id].last =  latestChannelMappingsById[id].last ? latestChannelMappingsById[id].last + 1 : null;
      channelMappingIdentifier.id = channelMappingsById[id].id;
      channelMappingsToPublish.push(channelMappingIdentifier);
    }

    this.setState({ channelMappingsById });

    const payload = this.convertToPublishRequestPayload(channelMappingsToPublish);
    this.client.publishChannelMapping(this.onPublishChannelMappingSuccess, this.onPublishChannelMappingFailure, payload);
  };

  convertToPublishRequestPayload = (channelMappingsToPublish) => {
    const payload = {};
    payload.channelMappings = channelMappingsToPublish;
    payload.username = this.props.user;

    return payload;
  };


  onPublishChannelMappingSuccess = (data) => {
    logger.info('Publishing channel mapping succeeded.');
    this.setState({ errorScreenMessage: null, successScreenMessage: "Successfully published" });
    this.refreshChannelMapping();
  };

  onPublishChannelMappingFailure = (error) => {
    logger.error(error);
    this.setState({ errorScreenMessage: extractErrorMessage(error) });
  };

  addChannelMappings = (channelMapping) => {
    let channelMappingsToAdd = [];
    channelMappingsToAdd.push(channelMapping);
    const payload = this.convertToAddRequestPayload(channelMappingsToAdd);
    this.client.addChannelMapping(this.onAddChannelMappingSuccess, this.onAddChannelMappingFailure, payload);
  };

  convertToAddRequestPayload = (channelMappingsToAdd) => {
    const payload = {};
    payload.channelMappings = channelMappingsToAdd;
    payload.username = this.props.user;

    return payload;
  };

  onAddChannelMappingFailure = (error) => {
    logger.error(extractErrorMessage(error), error);
    this.setState({ errorScreenMessage: extractErrorMessage(error) });
  };

  onAddChannelMappingSuccess = (result) => {
    this.setState({channelMappings: result.channelMappings, successScreenMessage: "Successfully staged added mapping" });
    this.refreshChannelMapping();
  };

  refreshChannelMapping = (successCallback) => {
    this.client.getChannelMappings((result) => {
      successCallback || this.onChannelMappingsPullSuccess(result)
    }, (error) => this.onChannelMappingsPullFailure(error));
  };

  onChannelMappingsPullFailure = (error) => {
    logger.error(extractErrorMessage(error), error);
    this.setState({ errorScreenMessage: extractErrorMessage(error) });
  };

  onChannelMappingsPullSuccess = (result) => {
    const channelMappingsById = (result.channelMappings || result.data.channelMappings).reduce((obj, item) => ({...obj, [item['id']]: item}), {});
    this.refreshDropdownElements(result.channelMappings || result.data.channelMappings);
    this.setState({ channelMappings: Object.values(channelMappingsById),
                    originalChannelMappings: channelMappingsById,
    });

    // Getting all staged mappings
    const payload = this.convertToStageRequestPayload([]);
    this.client.stageChannelMapping(this.onStageChannelMappingSuccess, this.onStageChannelMappingFailure, payload);
  };

  refreshDropdownElements = (channelMappings) => {
    this.setState({
       dropdownOptions: {
          hcpChannelTypeOptions: getHCPChannelTypeOptions(channelMappings),
          hcpChannelOptions: getHCPChannelOptions(channelMappings),
          cognosChannelOptions: getCognosChannelOptions(channelMappings),
          groupCodeOptions: getGroupCodeOptions(channelMappings),
          marketplaceIdOptions: getMarketplaceIdOptions(this.props.marketplaceConfig),
          cognosParentChannelOptions: getCognosParentChannelOptions(channelMappings),
       }
    })
  };

  onScreenDismiss = () => {
    this.setState({ errorScreenMessage: null, successScreenMessage: null })
  };

  render() {
    const {
      channelMappings,
      errorScreenMessage,
      successScreenMessage,
      channelMappingsById,
      originalChannelMappings
    } = this.state;

    return (
      <div>
      <div>
        <Flashbar
          items={
            errorScreenMessage
            ? [
                {
                  type: 'error',
                  dismissible: true,
                  content: `${ERROR_MESSAGE}${errorScreenMessage}`,
                  onDismiss: () => this.setState({ errorScreenMessage: null }),
                },
              ]
            : []
          }
        />
      </div>
      <div className="awsui-util-container">
        <ChannelMappingTable
          channelMappings={channelMappings}
          channelMappingsById={channelMappingsById}
          onScreenDismiss={this.onScreenDismiss}
          originalChannelMappings={originalChannelMappings}
          addChannelMappings={this.addChannelMappings}
          stageChannelMappingChanges={this.stageChannelMappingChanges}
          unstageChannelMappingChanges={this.unstageChannelMappingChanges}
          publishChannelMappingChanges={this.publishChannelMappingChanges}
          refreshChannelMapping={this.refreshChannelMapping}
          errorScreenMessage={errorScreenMessage}
          successScreenMessage={successScreenMessage}
          dropdownOptions={this.state.dropdownOptions}
          marketplaceConfig={this.props.marketplaceConfig}
          {...this.props}
        />
      </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/channel_mapping_container.jsx